"use client"
import { createListCollection } from "@ark-ui/react/select"
import type { ComponentProps, JSX } from "react"
import { createPortal } from "react-dom"

import { SelectComponent } from "./SelectParts"

type SelectItem = {
  value: string
  label: string
}

type SelectRootPropsWithItems = Omit<
  ComponentProps<typeof SelectComponent.Root>,
  "collection" | "children"
> & {
  items: SelectItem[]
  placeholder?: string
  label?: string
  clearable?: boolean
  children?: JSX.Element | JSX.Element[]
}

export const Select = (props: SelectRootPropsWithItems): JSX.Element => {
  const { items, placeholder, label, clearable = true, ...rootProps } = props
  const collection = createListCollection<SelectItem>({
    items,
  })
  const listContent = collection.items.map((item) => (
    <SelectComponent.Item
      key={item.value}
      item={item}
    >
      <SelectComponent.ItemText>{item.label}</SelectComponent.ItemText>
    </SelectComponent.Item>
  ))

  return (
    <SelectComponent.Root
      {...rootProps}
      //@ts-expect-error
      collection={collection}
    >
      <SelectComponent.HiddenSelect />
      {label ? (
        <SelectComponent.Label>{label}</SelectComponent.Label>
      ) : undefined}
      <SelectComponent.Control>
        <SelectComponent.Trigger>
          <SelectComponent.ValueText placeholder={placeholder} />
          <SelectComponent.IndicatorGroup>
            <SelectComponent.Indicator />
          </SelectComponent.IndicatorGroup>
        </SelectComponent.Trigger>
        {clearable ? <SelectComponent.ClearTrigger /> : undefined}
      </SelectComponent.Control>
      {createPortal(
        <SelectComponent.Positioner>
          <SelectComponent.Content>
            <SelectComponent.List>{listContent}</SelectComponent.List>
          </SelectComponent.Content>
        </SelectComponent.Positioner>,
        document.body,
      )}
    </SelectComponent.Root>
  )
}
